<template>
  <v-container id="campuses" fluid tag="section">
    <v-row justify="center">
      <v-col cols="12" md="12">
        <base-material-card
          :title="$i18n.t('Mileage by Vehicle Type')"
          icon="mdi-account-tie"
          class="px-3 py-3"
        >
          <v-card class="py-0 my-2" elevation="1" color="blue lighten-5 d-none d-md-flex">
            <v-card-text class="py-0">
              <v-row>
                <v-col cols="12" xs="12" sm="12">
                  <v-row>
                    <v-col cols="12" md="2"></v-col>
                    <v-col cols="12" md="5" justify="center">{{$i18n.t('Normal')}}</v-col>
                    <v-col cols="12" md="5" justify="center">{{$i18n.t('Outstation')}}</v-col>
                  </v-row>
                  <hr />
                  <v-row>
                    <v-col cols="12" md="2">{{$i18n.t('Vehicle Type')}}</v-col>
                    <v-col cols="12" md="1">{{$i18n.t('Petrol')}}</v-col>
                    <v-col cols="12" md="1">{{$i18n.t('Diesel')}}</v-col>
                    <v-col cols="12" md="1">{{$i18n.t('CNG')}}</v-col>
                    <v-col cols="12" md="2">{{$i18n.t('Electricity')}}</v-col>
                    <v-col cols="12" md="1">{{$i18n.t('Petrol')}}</v-col>
                    <v-col cols="12" md="1">{{$i18n.t('Diesel')}}</v-col>
                    <v-col cols="12" md="1">{{$i18n.t('CNG')}}</v-col>
                    <v-col cols="12" md="2">{{$i18n.t('Electricity')}}</v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
          <v-card v-for="mile in mileage" :key="mile.vehicleType" class="py-0 my-2" elevation="1">
            <v-card class="py-0 my-2" elevation="1">
              <v-card-text class="py-0">
                <v-row>
                  <v-col cols="12" xs="12" sm="12">
                    <v-row>
                      <v-col cols="12" md="2">{{mile.vehicleType}}</v-col>
                      <v-col cols="12" md="1">
                        <v-text-field
                          :label="$t('Petrol')"
                          class="purple-input"
                          v-model="mile.petrol"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-text-field
                          :label="$t('Diesel')"
                          class="purple-input"
                          v-model="mile.diesel"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-text-field :label="$t('CNG')" class="purple-input" v-model="mile.cng"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field
                          :label="$t('Electricity')"
                          class="purple-input"
                          v-model="mile.electric"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-text-field
                          :label="$t('Petrol')"
                          class="purple-input"
                          v-model="mile.petrolOS"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-text-field
                          :label="$t('Diesel')"
                          class="purple-input"
                          v-model="mile.dieselOS"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="12" md="1">
                        <v-text-field :label="$t('CNG')" class="purple-input" v-model="mile.cngOS"></v-text-field>
                      </v-col>
                      <v-col cols="12" md="2">
                        <v-text-field
                          :label="$t('Electricity')"
                          class="purple-input"
                          v-model="mile.electricOS"
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card>

          <v-col cols="12" class="text-right">
            <v-btn color="success" class="mr-0" @click="save()" :loading="loading">
              <h3>{{ $t("Save") }}</h3>
            </v-btn>
          </v-col>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { Vue, Component } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import common from "@/store/common/module/common";

@Component
export default class Holidays extends Vue {
  url = "/api/fuel/mileage/grid?_search=true";
  mileage = [];

  get loading() {
    return common.loading;
  }

  async mounted() {
    try {
      this.mileage = await doGet(this.url);
    } catch (e) {
      common.setError(e.message);
    }
  }

  async save() {
    try {
      common.setLoading(true);
      await doPost("/api/fuel/mileage/save", this.mileage);
      common.setLoading(false);
      common.showMessage("Saved Successfully");
    } catch (e) {
      common.setError(e);
      common.setLoading(false);
    }
  }
}
</script>

<style scoped>
.pac-target-input {
  width: 50%;
  border: 1px solid #dfdfdf;
  height: 30px;
  padding: 10px 20px;
  z-index: 1;
  background: white;
  margin-left: 25%;
  position: absolute;
  margin-top: 10px;
}
#bookingCheckbox {
  margin-left: 20px;
  margin-right: 20px;
  justify-content: space-between;
}
</style>
